import { func, string, bool } from 'prop-types';
import React from 'react';
import { TableBody as TableBodyWrapper, TableCell } from '@mui/material';
import Box from '@mui/material/Box';
import { usePaymentsHandler } from './hooks';
import { Checkbox } from '../atoms';
import { StyledTableRow } from '../table/styled';
import useTableContext from './TableContext';

const TableBody = ({
  loaderRefFn,
  customDetailsPathname,
  customDetailsId,
  customDetailsPathParam,
  noCheckBox,
  disableRowClick,
  noLastRowBorder,
  trHeight,
}) => {
  const { getTableBodyProps, rows, prepareRow, checkboxEditMode } = useTableContext();

  const { handleOnClick, handleSelect, isSelected } = usePaymentsHandler({
    rows,
    customDetailsPathname,
    customDetailsId,
    customDetailsPathParam,
  });

  const handleClick = (e, row) => {
    if (disableRowClick) return;

    handleOnClick(e, row?.original);
  };

  return (
    <TableBodyWrapper {...getTableBodyProps()}>
      {rows.map((row) => {
        const ID = row?.original?.paymentId || row?.original?.['payment id'] || row?.original?.id;
        const sourceId = row?.original?.sourceId || row?.original?.['source id'];

        const isItemSelected = isSelected(ID);
        const labelId = `enhanced-table-checkbox-${ID}`;
        prepareRow(row);

        return (
          <StyledTableRow
            {...row.getRowProps()}
            hover
            onClick={handleClick}
            role="checkbox"
            aria-checked={isItemSelected}
            tabIndex={-1}
            selected={isItemSelected}
            data-rowid={ID}
            {...(sourceId !== 'N/A' ? { 'data-sourceId': sourceId } : {})}
            $checkboxEditMode={checkboxEditMode ? 1 : 0}
            $noCheckBox={noCheckBox}
            $noLastRowBorder={noLastRowBorder}
            $trHeight={trHeight}
          >
            {!checkboxEditMode && !noCheckBox && (
              <TableCell padding="checkbox">
                <Checkbox
                  checked={isItemSelected}
                  name={labelId}
                  aria-labelledby={labelId}
                  onClick={handleSelect}
                  onChange={() => {}}
                  data-rowid={ID}
                />
              </TableCell>
            )}

            {row.cells.map((cell) => {
              const key = cell.getCellProps();
              return <React.Fragment key={key?.key}>{cell.render('Cell')}</React.Fragment>;
            })}
          </StyledTableRow>
        );
      })}
      {/* Helper ref for useInfiniteHorizontalScroll */}
      {checkboxEditMode && (
        <Box
          visibility="hidden"
          opacity="0"
          height="100%"
          width="130px"
          ref={loaderRefFn}
          bgcolor="red"
          position="absolute"
          top="0"
          right="0"
        >
          &nbsp;
        </Box>
      )}
    </TableBodyWrapper>
  );
};

TableBody.propTypes = {
  loaderRefFn: func.isRequired,
  customDetailsPathname: string,
  customDetailsId: string,
  customDetailsPathParam: string,
  noCheckBox: bool,
  disableRowClick: bool,
  noLastRowBorder: bool,
  trHeight: string,
};
TableBody.defaultProps = {
  customDetailsPathname: null,
  customDetailsId: null,
  customDetailsPathParam: null,
  noCheckBox: false,
  disableRowClick: false,
  noLastRowBorder: false,
  trHeight: null,
};

export default TableBody;
